const GlobalDatesMixin = {
  computed: {
    nowISOString() {
      const date = new Date();
      const options = {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const arrayDate = date.toLocaleString("en-US", options).split("/");
      const now = `${arrayDate[2]}-${arrayDate[0]}-${arrayDate[1]}`;
      return now;
    },
    coverageMinStartDate() {
      return this.moment(this.nowISOString).add(1, "days").format("MM/DD/YYYY");
    },
    coverageSameDateStartDate() {
      return this.moment(this.nowISOString).format("MM/DD/YYYY");
    },
  },
  methods: {
    setPageTitle(title) {
      if (title && global.isClientSide) {
        document.title = title;
      }
    },
  },
};

export default GlobalDatesMixin;
